import React from 'react'

export default function Logo({ width = 85, height, className }) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 108.02 107.78"
      width={width}
      height={height}
      className={className}
      role="img"
      aria-label="The Mobile Food Alliance"
      id="Layer_1"
    >
      <defs>
        <style>{`.cls-1{fill:#fff;}.cls-2{fill:#e73834;}`}</style>
      </defs>
      <circle className="cls-2" cx="54.33" cy="53.7" r="53.7"/>
      <polygon className="cls-1" points="69.29 44.36 69.29 37.94 53.46 37.94 45.52 37.94 43.74 37.94 35.11 56.67 26.4 37.94 16.94 37.94 16.94 65.84 24.91 65.84 24.56 50.46 31.92 65.84 38.05 65.84 45.52 49.91 45.52 52.23 45.18 65.84 45.52 65.84 53.13 65.84 53.46 65.84 53.46 55.87 67.15 55.87 67.15 49.3 53.46 49.3 53.46 44.36 69.29 44.36"/>
      <path className="cls-1" d="M85.44,62.09h-10.68l-1.23,3.75h-8.76l10.2-27.89h10.55l10.2,27.89h-9.02l-1.27-3.75ZM76.69,56.11h6.83l-3.42-10.28-3.42,10.28Z"/>
    </svg>
  )
}
